export const CREATE_ACCOUNT_SESSION_MUTATION = `
  mutation CreateAccountSession($input: CreateAccountSessionInput) {
    createAccountSession(input: $input) {
      accountSessionId
      accountUrl
      expiresAt
      ttlSeconds
    }
  }
`;
